import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

/**
 * Placeholder for the AP sticky bottom bar: one row standing in for the price
 * and the CTA, kept at the height of the loaded content so the bar doesn't
 * jump once rooms arrive.
 */
export const PrimaryRoomOfferCompactLoading = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    height="48px"
  >
    <SkeletonLoader width={86} marginTop={0} />
    <SkeletonLoader width={86} marginTop={0} />
  </Box>
)
